import * as React   from "react";
import {cs}         from "@Common/react/chain-services";
import {UseState}   from "@Common/react/use-state";
import {equalDeep}  from "@Common/utils/objects";

import "./selections-section.scss";

import {cx}                         from "emotion";
import {SelectTargetSection}        from "../../step-1-select-target/select-target-section/select-target-section";
import {groupSections}              from "../../common/group-sections";
import {DemographicsSection}        from "./demographics-section/demographics-section";
import {PoBoxSection}               from "./po-box-section/po-box-section";

export const SelectionsSection = ({poRoutes, searchRequest, selecteds, viewSize, next}) => cs(
    ["tab", (_, next) => UseState({
        initValue: "targets",
        next,
    })],
    ["show", (_, next) => UseState({
        initValue: true,
        next,
    })],
    ["selectTargetSection", ({}, next) => SelectTargetSection({next})],
    ["demographicsSection", ({}, next) => DemographicsSection({next})],
    ["poBoxSection", ({}, next) => PoBoxSection({poRoutes, selecteds, next})],
    ["groupedSections", ({selectTargetSection, demographicsSection}, next) => next(
        groupSections([selectTargetSection, demographicsSection])
    )],
    ["searchEqualDeep", ({selectTargetSection, demographicsSection}, next) => next(
        equalDeep(searchRequest.selections, {
            ...selectTargetSection.getSearchRequest(),
        }) &&
        equalDeep(searchRequest.demographics, demographicsSection.demographics)
    )],
    ({selectTargetSection, demographicsSection, poBoxSection, groupedSections, tab, show, searchEqualDeep}) => next({
        getSearchRequest: () => ({
            ...selectTargetSection.getSearchRequest(),
        }),
        demographics: demographicsSection.demographics,
        openPoBoxTab: () => {
            tab.onChange("poBoxes");
            show.onChange(true);
        },
        render: ({onApply}) => cs(
            ["showErrors", (_, next) => UseState({next})],
            ({showErrors}) => (
                <div className={cx("selections-section-g7q", {disabled: !show.value})}>
                    <div {...{
                        className: "toggle",
                        onClick: () => show.onChange(!show.value),
                        "xd-qa-name": "Neighborhood Search Toggle",
                        "xd-qa-type": "button",
                    }}>
                        <span>{show.value ? "<" : ">"}</span>
                    </div>
                    <div className="sidebar">
                        {!!poRoutes?.length && (
                            <div className="header">
                                {tabs.map((t, i) => (
                                    <div {...{
                                        key: i,
                                        className: cx("tab", {active: tab.value === t.value}),
                                        onClick: () => tab.onChange(t.value),
                                        "xd-qa-name": `Neighborhood Search ${t.label} Tab`,
                                        "xd-qa-type": "button"
                                    }}>
                                        {t.label}
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className={cx("content", {search: !poRoutes?.length, "po-boxes": tab.value === "poBoxes"}, viewSize)}>
                            {tab.value === "targets" ? <>
                                {selectTargetSection.render({showErrors: showErrors.value})}
                                {demographicsSection.render({showErrors: showErrors.value})}
                            </> : (
                                poBoxSection.render({showErrors: showErrors.value})
                            )}
                        </div>

                        {tab.value === "targets" && (
                            <div className="footer">
                                {cs(
                                    ["submitting", (_, next) => UseState({next})],
                                    ({submitting}) => (
                                        <button {...{
                                            className: cx("next", {
                                                disabled: !groupedSections.valid,
                                            }),
                                            disabled: submitting.value || searchEqualDeep,
                                            onClick: async () => {
                                                if (!groupedSections.valid) {
                                                    if (!showErrors.value) {
                                                        showErrors.onChange(true);
                                                    }
                                                    groupedSections.highlightErrors();
                                                } else {
                                                    submitting.onChange(true);

                                                    try {
                                                        await onApply();
                                                        show.onChange(false);
                                                    } catch (error) {
                                                        groupedSections.handleApiError(error);
                                                    } finally {
                                                        submitting.onChange(false);
                                                    }
                                                }
                                            },
                                            "xd-qa-type": "button",
                                            "xd-qa-name": "Neighborhood Search View Results",
                                        }}>
                                            {!submitting.value ? (
                                                (!searchRequest.selections ? "View " : "Refresh ") + "Results"
                                            ) : (
                                                "Searching..."
                                            )}
                                        </button>
                                        )
                                    )}
                            </div>
                        )}
                    </div>
                </div>
            ),
        ),
    })
);

const tabs = [
    {
        label: "Targets",
        value: "targets",
    },
    {
        label: "PO Boxes",
        value: "poBoxes",
    }
]